/**
 * Where the installed PWA lands on launch (manifest start_url points at
 * /portal/start). An admin session wins (the installed app is the team's
 * too, spec 2026-10-15); then stored portal sessions; otherwise the login
 * page.
 *
 * TD-016: one session routes directly by its role; with several sessions
 * there is no defensible automatic pick (one email can be client at one
 * business and creator at another), so the caller shows a workspace
 * chooser. Session presence is refresh-capable, not access-token-valid —
 * see listRefreshablePortalSessions.
 */
import { portalSurfacePath } from "@/core/auth/portalSurface";

export interface PortalStartSession {
  clientId: string;
  role: string;
}

/** Returns the launch path, or null when the caller must render the chooser.
 * An admin session wins: the installed app is the team's too (spec 2026-10-15). */
export function resolvePortalStart(
  sessions: PortalStartSession[],
  hasAdminSession = false
): string | null {
  if (hasAdminSession) return "/";
  if (sessions.length === 0) return "/portal/login";
  if (sessions.length === 1) {
    return portalSurfacePath(sessions[0].role, sessions[0].clientId);
  }
  return null;
}
